module.exports = __webpack_public_path__ + "img/a104b3c.png";